import React from 'react'

function Footer(){
    return (
        <>
            <footer class="footer">
                <p>&copy;Created by Sarthak Nirgude | All Rights Reserved</p>
            </footer>
        </>
    )
}

export default Footer;